import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { sendFrontAction } from '../../services/api';
import { resolveImage } from '../../utils/storageUrl';
import CarCard from '../../components/CarCard/CarCard';
import './CarDetail.css';

const CarDetail = () => {
    const { type, id } = useParams();
    const isUsed = type === 'used';

    const [car, setCar] = useState(null);
    const [similar, setSimilar] = useState([]);
    const [activeImage, setActiveImage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setNotFound(false);
            try {
                const data = await sendFrontAction('car_detail', { id, type });
                if (data.success) {
                    setCar(data.car);
                    setSimilar(data.similar || []);
                    setActiveImage(0);
                } else {
                    setNotFound(true);
                }
            } catch (e) {
                console.error('Ошибка загрузки карточки авто:', e);
                setNotFound(true);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id, type]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') setLightboxOpen(false);
        };
        if (lightboxOpen) {
            window.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden'; // блокируем скролл фона
        }
        return () => {
            window.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [lightboxOpen]);

    if (loading) return <div className="car-detail-loader">Загрузка...</div>;
    if (notFound || !car) return <div className="car-detail-loader">Автомобиль не найден</div>;

    const gallery = car.gallery && car.gallery.length > 0 ? car.gallery : [car.image_path];

    return (
        <div className="car-detail-container">
            <Link to={`/catalog/${type}`} className="car-detail-back-link">‹ Назад к каталогу</Link>

            <h1 className="car-detail-title">{car.name}</h1>

            <div className="car-detail-top-section">
<div className="car-detail-gallery-block">
    <div
        className="car-detail-main-image-wrapper"
        onClick={() => setLightboxOpen(true)}
    >
        <img
            src={resolveImage(gallery[activeImage])}
            alt={car.name}
            className="car-detail-main-image"
        />
        <span className="car-detail-zoom-hint">🔍 Увеличить</span>
    </div>
    {gallery.length > 1 && (
        <div className="car-detail-thumb-row">
            {gallery.map((img, i) => (
                <img
                    key={i}
                    src={resolveImage(img)}
                    alt={`${car.name} фото ${i + 1}`}
                    onClick={() => setActiveImage(i)}
                    className={`car-detail-thumb ${i === activeImage ? 'active' : ''}`}
                />
            ))}
        </div>
    )}
</div>

{lightboxOpen && (
    <div
        className="car-detail-lightbox-overlay"
        onClick={() => setLightboxOpen(false)}
    >
        <button
            className="car-detail-lightbox-close"
            onClick={() => setLightboxOpen(false)}
            aria-label="Закрыть"
        >
            ✕
        </button>
        <img
            src={resolveImage(gallery[activeImage])}
            alt={car.name}
            className="car-detail-lightbox-image"
            onClick={(e) => e.stopPropagation()} // клик по самой картинке не закрывает окно
        />
        {gallery.length > 1 && (
            <>
                <button
                    className="car-detail-lightbox-nav car-detail-lightbox-prev"
                    onClick={(e) => {
                        e.stopPropagation();
                        setActiveImage((prev) => (prev === 0 ? gallery.length - 1 : prev - 1));
                    }}
                    aria-label="Предыдущее фото"
                >
                    ‹
                </button>
                <button
                    className="car-detail-lightbox-nav car-detail-lightbox-next"
                    onClick={(e) => {
                        e.stopPropagation();
                        setActiveImage((prev) => (prev === gallery.length - 1 ? 0 : prev + 1));
                    }}
                    aria-label="Следующее фото"
                >
                    ›
                </button>
            </>
        )}
    </div>
)}

                <div className="car-detail-info-block">
                    <table className="car-detail-spec-table">
                        <tbody>
                            <tr><td className="car-detail-spec-label">Двигатель</td><td>{car.engine_type || '—'}</td></tr>
                            {car.power_hp && (
                                <tr><td className="car-detail-spec-label">Мощность л.с.</td><td>{car.power_hp}</td></tr>
                            )}
                            <tr><td className="car-detail-spec-label">Кузов</td><td>{car.body_type || '—'}</td></tr>
                            <tr><td className="car-detail-spec-label">КПП</td><td>{car.transmission_type || '—'}</td></tr>
                            {car.drive_type && (
                                <tr><td className="car-detail-spec-label">Привод</td><td>{car.drive_type}</td></tr>
                            )}
                            <tr><td className="car-detail-spec-label">Цвет кузова</td><td>{car.color_name || '—'}</td></tr>
                            {isUsed && car.mileage && (
                                <tr><td className="car-detail-spec-label">Пробег</td><td>{car.mileage.toLocaleString('ru-RU')} км</td></tr>
                            )}
                        </tbody>
                    </table>

                    <div className="car-detail-price">
                        {Number(car.price).toLocaleString('ru-RU')} EUR*
                    </div>
                    <div className="car-detail-price-note">
                        В наличии {car.is_active_installment && 'в рассрочку'} * Информация о ценах является ориентировочной и не публичной офертой
                    </div>

                    <div className="car-detail-cta-row">
                        {/* <Link to={`/poluchit-predlozhenie?model_id=${car.id}&type=${type}`} className="car-detail-cta-btn-primary">
                            Получить обратный связь
                        </Link> */}
                        {!isUsed && (
                            <Link to={`/poluchit-predlozhenie?model_id=${car.id}&type=${type}&les=1`} className="car-detail-cta-btn">
                                Предложение в рассрочку
                            </Link>
                        )}
                        {car.is_active_testdrive && (
                            <Link to="/test-drive-appointment" className="car-detail-cta-btn">Записаться на тест-драйв</Link>
                        )}
                        <Link to="/visit_showroom" className="car-detail-cta-btn">Онлайн-запись на визит</Link>
                    </div>
                </div>
            </div>

            {car.options && car.options.length > 0 && (
                <div className="car-detail-options-section">
                    <h2 className="car-detail-section-title">Опциональное оснащение автомобиля</h2>
                    <div className="car-detail-options-grid">
                        {car.options.map((opt, i) => (
                            <div key={i} className="car-detail-option-item">
                                {opt.code ? `${opt.code} ${opt.name}` : opt.name}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {similar.length > 0 && (
                <div className="car-detail-similar-section">
                    <h2 className="car-detail-section-title">Ещё предложения</h2>
                    <div className="car-detail-similar-grid">
                        {similar.map(item => (
                            <CarCard
                                key={item.id}
                                car={{ ...item, displayPrice: item.price }}
                                isUsed={isUsed}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarDetail;